// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2i45B","signatureBlock":"Footer_signatureBlock__2p_jh","signature":"Footer_signature__3sCBr"};